import angular from "angular";

import OrganisationOwnerProfileModuleRouting from "./organisation-owner-profile.module.routing";

export default angular
  .module("vt-organisation-owner-profile", [])
  .config(OrganisationOwnerProfileModuleRouting);
